module.exports = __webpack_public_path__ + "static/01-24be1a7338300716d1b3b6ab74d2d407.jpg";